import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  IconButton,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useDispatch, useSelector } from "react-redux";
import CollapseIcon from "../../common/images-new/collapse-icon.svg";
import ExpandIcon from "../../common/images-new/expand-icon.svg";
import NIEIcon from "../../common/images-new/NIE-ChatBot-icon.svg";
import Button from "../../components/Button/Button";
import ButtonChatBot from "../../components/Button/ButtonChatBot";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CROSS_BLACK_ICON from "@mui/icons-material/Clear";
import axios from "axios";
import Swal from "sweetalert2";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { serverUrl } from "../../components/Helpers/Config";
import ReactMarkdown from "react-markdown";
import { MenuItemCard, MenuItemDiv } from "../../pages/Theme";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import 'github-markdown-css/github-markdown.css';
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Popover from "@mui/material/Popover";
import ChatBotMarkDownContent from "./ModalChatBotMarkDownContent";
import { ContactSupportOutlined } from "@mui/icons-material";

const Chatbot = ({ handleClose, show, chatbot_id }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isCitations, setIsCitations] = useState(false);
  const [isMobile, setisMobile] = useState(true);
  const isUserDetails = useSelector((state) => state.auth.user);
  const [requestId, setRequestId] = useState("");
  const controllerRef = useRef(null);
  const [dropdown, setDropdown] = useState(false);
  const bottomRef = useRef(null);
  const popupRef = useRef();
  const textareaRef = useRef(null);
  const [isSessionID, setIsSessionID] = useState(null);
  const [chatbotDetails, setChatbotDetails] = useState([]);
  const [downloadChat, setDownloadChat] = useState("Download Current Chat");
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const [citationsRecords, setCitationsRecords] = useState([]);
  const [citationsContent, setCitationsContent] = useState();

  useEffect(() => {
    getSessionResponse();
    axios
      .get(serverUrl.ChatBotDetails + "/" + chatbot_id)
      .then((resp) => {
        if (resp.status === 200) {
          setChatbotDetails(resp?.data?.results);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  }, []);

  const getSessionResponse = () => {
    axios
      .get(serverUrl.ChatBotSession)
      .then((resp) => {
        if (resp.status === 200) {
          setIsSessionID(resp?.data?.session_id);
          setMessages(resp?.data?.messages);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);

    return () => clearTimeout(timeout);
  }, [show]);

  useEffect(() => {
    // Scroll to the bottom every time messages change
    const timeout = setTimeout(() => {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);

    return () => clearTimeout(timeout);
  }, [messages]);

  useEffect(() => {
    const handleClick = (e) => {
      if (!popupRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClick, false);
    return function cleanup() {
      document.removeEventListener("mousedown", handleClick, false);
    };
  });

  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };
  function fallbackUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const handleSend = async (value) => {
    let citationsList = [];
    handleChange();
    setFollowUpQuestions([]);
    setIsCitations(false);
    setCitationsContent("");
    //setCitationsRecords([]);
    const request_id =
      typeof crypto?.randomUUID === "function"
        ? crypto?.randomUUID()
        : fallbackUUID();
    setRequestId(request_id);
    let text = value ? value : input;
    if (text?.trim() === "") return;
    setMessages((prev) => [...prev, { prompt: text, response: null }]);
    setInput("");
    setLoading(true);
    // if (controllerRef.current) controllerRef.current.abort();
    // const controller = new AbortController();
    // controllerRef.current = controller;
    const token = localStorage.getItem("dp2_token_access");
    try {
      const response = await fetch(serverUrl.ChatBotResponse, {
        method: "POST",
        //signal: controller.signal,
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify({
          chatbot_id: isUserDetails.chatbot_id,
          prompt: text?.trim(),
          request_id: request_id,
          session_id: isSessionID,
        }),
      });

      if (!response.ok || !response.body) {
        setLoading(false);
        return;
      }
      const contentType = response.headers.get("Content-Type");
      if (contentType?.includes("text/event-stream")) {
        // Stream handling
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let splitIndex = -1;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          // Decode the stream chunk and append to the buffer
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          // Stop if the buffer says "[DONE]"
          if (buffer.trim() === "[DONE]") {
            setLoading(false);
            setFollowUpQuestions([]);
            setIsCitations(false);
            setCitationsContent("");
            //setCitationsRecords([]);
            return;
          }
          splitIndex = buffer?.lastIndexOf("</html>");
          if (splitIndex < 0) {
            setMessages((prev) => {
              if (prev.length === 0) return prev;

              const updated = [...prev];
              const last = updated[updated.length - 1];

              updated[updated.length - 1] = {
                ...last,
                response:
                  buffer?.replace("```html", "")?.split("</html>")[0] || "",
                citations: null,
              };

              return updated;
            });
          }
        }
        // let resultStr = buffer || "";
        // const jsonRaw = buffer?.slice(splitIndex + 7)?.trim();
        // const match = jsonRaw.match(/\[[\s\S]*\]$/);
        // const arrayMatches = [...jsonRaw.matchAll(/\[[\s\S]*?\]/g)];
        // let textPart = "";
        // if (match && splitIndex !== -1) {
        //     try {
        //         textPart = resultStr.slice(0, splitIndex + 7).trim();
        //     } catch (e) {
        //         console.error(e);
        //     }
        // } else if (match) {
        //     // If JSON is present but no HTML, extract only the part before JSON
        //     textPart = resultStr.slice(0, match.index).trim();
        // } else {
        //     // If there's no JSON, treat the whole result as plain text
        //     textPart = resultStr.trim();
        // }
        // for (const match of arrayMatches) {
        //     const jsonPart = match[0];
        //     try {
        //         const parsed = JSON?.parse(jsonPart);

        //         if (Array.isArray(parsed)) {
        //             if (parsed.length === 0) continue;

        //             if (typeof parsed[0] === "string") {
        //                 setFollowUpQuestions(parsed);
        //             } else if (typeof parsed[0] === "object" && parsed[0] !== null) {
        //                 //setCitationsRecords(parsed);
        //                 citationsList = parsed;
        //             }
        //         }
        //     } catch (e) {
        //     }
        // }
        // let finalData = textPart;
        // const cleanedBuffer = finalData?.replace('```html', '');
        // const result = splitIndex !== -1
        //     ? cleanedBuffer?.slice(0, splitIndex + 7)?.trim()
        //     : cleanedBuffer?.trim();
        // setMessages((prev) => {
        //     if (prev.length === 0) return prev;

        //     const updated = [...prev];
        //     const last = updated[updated.length - 1];

        //     updated[updated.length - 1] = {
        //         ...last,
        //         response: result?.split('</html>')[0] || '',
        //         citations: citationsList || null
        //     };

        //     return updated;
        // });
        handleBuffer(buffer);
      } else {
        // Non-stream handling
        const result = await response.json();
        const resultStr = result.results || "";
        handleBuffer(result.results);
        //     const splitIndex = result.results?.lastIndexOf('</html>');
        //     const jsonRaw = result.results?.slice(splitIndex + 7)?.trim();
        //     const match = jsonRaw.match(/\[[\s\S]*\]$/);
        //     const arrayMatches = [...jsonRaw.matchAll(/\[[\s\S]*?\]/g)];
        //     let textPart = "";
        //     if (match && splitIndex !== -1) {
        //         try {
        //             textPart = resultStr.slice(0, splitIndex + 7).trim();
        //         } catch (e) {
        //             console.error(e);
        //         }
        //     } else if (match) {
        //         // If JSON is present but no HTML, extract only the part before JSON
        //         textPart = resultStr.slice(0, match.index).trim();
        //     } else {
        //         // If there's no JSON, treat the whole result as plain text
        //         textPart = resultStr.trim();
        //     }
        //     for (const match of arrayMatches) {
        //         const jsonPart = match[0];
        //         try {
        //             const parsed = JSON?.parse(jsonPart);
        //             if (Array.isArray(parsed)) {
        //                 if (parsed.length === 0) continue;

        //                 if (typeof parsed[0] === "string") {
        //                     setFollowUpQuestions(parsed);
        //                 } else if (typeof parsed[0] === "object" && parsed[0] !== null) {
        //                     //setCitationsRecords(parsed);
        //                     citationsList = parsed;
        //                 }
        //             }
        //         } catch (e) {
        //             console.log(e);
        //         }
        //     }
        //     setMessages((prev) => {
        //         if (prev.length === 0) return prev;
        //         const updated = [...prev];
        //         const last = updated[updated.length - 1];

        //         updated[updated.length - 1] = {
        //             ...last,
        //             response: textPart?.replace('```html', '')?.split('</html>')[0] || '',
        //             citations: citationsList || null
        //         };

        //         return updated;
        //     });
      }
      setLoading(false);
    } catch (error) {
      tokenAuthorize(error?.response?.status);
      setLoading(false);
    }
  };

  function sanitizeResponseString(input) {
    return input
      .replace(/```(json|html)?/g, "")
      .replace(/\\n/g, "\n")
      .replace(/^\s+|\s+$/g, "") // trim leading/trailing spaces
      .replace(/\n{3,}/g, "\n\n"); // limit blank lines
  }
  function fixEncoding(str) {
    try {
      return decodeURIComponent(escape(str));
    } catch {
      return str;
    }
  }
  // Extracted parsing logic for reuse
  function handleBuffer(buffer) {
    // let splitIndex = buffer.lastIndexOf("</html>");
    // const resultStr = buffer || "";
    // const jsonRaw = buffer.slice(splitIndex + 7).trim();
    // const match = jsonRaw.match(/\[[\s\S]*\]$/);
    // const arrayMatches = [...jsonRaw.matchAll(/\[[\s\S]*?\]/g)];
    // let citationsList = null;
    // let textPart = "";

    // if (match && splitIndex !== -1) {
    //     textPart = resultStr.slice(0, splitIndex + 7).trim();
    // } else if (match) {
    //     textPart = resultStr.slice(0, match.index).trim();
    // } else {
    //     textPart = resultStr.trim();
    // }

    // for (const match of arrayMatches) {
    //     const jsonPart = match[0];
    //     try {
    //         const parsed = JSON.parse(jsonPart);
    //         if (Array.isArray(parsed)) {
    //             if (typeof parsed[0] === "string") {
    //                 setFollowUpQuestions(parsed);
    //             } else if (typeof parsed[0] === "object") {
    //                 citationsList = parsed;
    //             }
    //         }
    //     } catch (e) {
    //     }
    // }

    // let cleanedBuffer = sanitizeResponseString(textPart?.replace("```html", "").trim());

    // if (cleanedBuffer?.includes("</html>")) {
    //     cleanedBuffer = cleanedBuffer.split("</html>")[0].trim();
    // }
    // setMessages((prev) => {
    //     if (prev.length === 0) return prev;
    //     const updated = [...prev];
    //     const last = updated[updated.length - 1];
    //     updated[updated.length - 1] = {
    //         ...last,
    //         response: cleanedBuffer || "",
    //         citations: citationsList || null,
    //     };
    //     return updated;
    // });

    const resultStr = buffer || "";
    const splitIndex = resultStr.lastIndexOf("</html>");
    // 1. Extract HTML or raw text
    const htmlPart =
      splitIndex !== -1
        ? resultStr.slice(0, splitIndex + 7).trim()
        : resultStr.trim();
    const jsonRaw =
      splitIndex !== -1 ? resultStr.slice(splitIndex + 7).trim() : "";

    const arrayMatches = [
      ...jsonRaw.matchAll(
        /\[\s*(\{[\s\S]*?\}\s*,?\s*)+\]|\[\s*"[^"]*"(?:\s*,\s*"[^"]*")*\s*\]/g
      ),
    ];

    let citationsList = null;

    for (const match of arrayMatches) {
      const jsonPart = match[0];
      try {
        const parsed = JSON.parse(jsonPart);
        if (Array.isArray(parsed)) {
          if (typeof parsed[0] === "string") {
            setFollowUpQuestions(parsed);
          } else if (typeof parsed[0] === "object") {
            citationsList = parsed;
          }
        }
      } catch (err) {
        console.warn("Invalid JSON part:", jsonPart);
      }
    }
    const cleanedText = sanitizeResponseString(htmlPart);
    const fixed = fixEncoding(cleanedText);
    // Known safe end phrases
    const endPhrases = [
      "I’m sorry, I don’t have that information right now.",
      "I'm sorry, I don't have that information right now.",
    ];
    let finalResponse = fixed;
    for (const phrase of endPhrases) {
      const idx = fixed.indexOf(phrase);
      if (idx !== -1) {
        finalResponse = fixed.slice(0, idx + phrase.length).trim();
        break;
      }
    }
    if (finalResponse.includes("</html>")) {
      finalResponse = finalResponse.split("</html>")[0];
    }

    setMessages((prev) => {
      if (prev.length === 0) return prev;
      const updated = [...prev];
      const last = updated[updated.length - 1];
      updated[updated.length - 1] = {
        ...last,
        response: finalResponse,
        citations: citationsList || null,
      };
      return updated;
    });
  }

  const handleStop = () => {
    try {
      let data = {
        request_id: requestId,
      };
      axios
        .post(serverUrl.ChatBotStopResponse, data)
        .then((resp) => {
          if (resp.status === 200) {
            // if (controllerRef.current) controllerRef.current.abort();
            setLoading(false);
          }
        })
        .catch((err) => {
          //tokenAuthorize(err?.response?.status);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };
  const handleCitations = () => {
    setIsCitations(!isCitations);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      resize();
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setIsFullScreen(false);
  }, [show]);

  const resize = () => {
    if (window.innerWidth < 648) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
  };
  // Refs to the down arrow and the target section
  const arrowRef = useRef(null);
  const sectionRef = useRef(null);
  const [atTop, setAtTop] = useState(false);
  useEffect(() => {
    const scrollElement = sectionRef.current;

    const handleScroll = () => {
      if (!scrollElement) return;
      const scrollTop = scrollElement.scrollTop;
      const scrollHeight = scrollElement.scrollHeight;
      const clientHeight = scrollElement.clientHeight;
      // If NOT at the bottom (allowing a 20px buffer)
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 25;
      setAtTop(!isAtBottom);
    };
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }
    // Cleanup on unmount
    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScrollToSection = () => {
    // Scroll to the bottom
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const btnQuestion = (question) => {
    handleSend(question);
  };

  const handleChange = (e) => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto";
    textarea.style.height = "75px";
  };

  const handleDownload = async () => {
    try {
      setDownloadChat("Loading...");
      let url = serverUrl.ChatBotResponseDownload;
      let data = { session_id: isSessionID };
      const response = await axios.post(`${url}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      });
      if (response.status === 200) {
        // Extract Content-Disposition header
        const contentDisposition =
          (response.headers && response.headers["content-disposition"]) ||
          response.headers["Content-Disposition"];
        // Default filename
        let filename = "chatbot-response.pdf";
        // Extract filename from Content-Disposition
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, ""); // Remove quotes if present
          }
        }
        // Create Blob and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        setDownloadChat("Download Current Chat");
      } else {
        setDownloadChat("Download Current Chat");
        Swal.fire({
          title: "Info",
          text: "No data found",
          icon: "info",
        });
      }
    } catch (err) {
      console.error("Error:", err);
      setDownloadChat("Download Current Chat");
      Swal.fire({
        title: "Info",
        text: "No data found",
        icon: "info",
      });
    }
  };

  const handleClearChat = () => {
    let data = {
      session_id: isSessionID,
    };
    axios
      .put(serverUrl.ChatBotCloseSession, data)
      .then((resp) => {
        if (resp.status === 200) {
          getSessionResponse();
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };

  const handleDelete = () => {
    handleClearChat();
    setFollowUpQuestions([]);
    setIsCitations(false);
    setCitationsContent("");
    //setCitationsRecords([]);
    setMessages([]);
    setAtTop(false);
    setAnchorEl(null);
    setLoading(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopupClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopupClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (show && isFullScreen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden"; // <== Add this
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [show, isFullScreen]);

  const showHideModal = show
    ? isFullScreen
      ? "fixed inset-0 w-full h-full bg-black bg-opacity-60 modelIndex overflow-auto flex items-center justify-center"
      : isMobile
      ? "fixed inset-0 w-full h-full bg-black bg-opacity-60 modelIndex overflow-auto flex items-center justify-center"
      : `fixed bottom-16 right-16 modelIndex rounded-lg`
    : "hidden";
  return (
    <div className={showHideModal}>
      <div
        className={`shadow-lg rounded-lg overflow-hidden p-2 max-w-full bg-gray-200  ${
          isFullScreen
            ? "w-10/12"
            : isCitations
            ? "chatBot-Width"
            : "chatBot-Width-WithOutCitation"
        }`}
      >
        {/* Header */}
        <div className="bg-gray-200 p-2 flex justify-between">
          <div className="flex gap-1.5">
            <img className="w-6" alt="NIEIcon" src={NIEIcon} />
            <span className="text-black text-md font-semibold">
              {chatbotDetails[0]?.title}
            </span>
          </div>
          <div className="flex gap-2">
            <div
              ref={popupRef}
              className="items-center hidden"
              onClick={toggleDropdown}
            >
              <MoreHorizIcon className="cursor-pointer hover:opacity-80" />
              {dropdown && (
                <MenuItemCard
                  className={`absolute bg-white right-0 mt-10 p-3 rounded-md filter 
                            drop-shadow transform z-10 translate-y-12 ${
                              isFullScreen
                                ? "-translate-x-16"
                                : "-translate-x-4"
                            } `}
                >
                  <li className="md:pb-2 pl-2">
                    <MenuItemDiv
                      className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                      onClick={() => {
                        setMessages([]);
                        setLoading(false);
                      }}
                    >
                      <p className="text-sm ">Clear Chat</p>
                    </MenuItemDiv>
                    <MenuItemDiv
                      className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                      //onClick={() => history.push()}
                    >
                      <p className="text-sm ">Download Current Chat</p>
                    </MenuItemDiv>
                  </li>
                </MenuItemCard>
              )}
            </div>
            <img
              className="w-4 cursor-pointer hover:opacity-60"
              onClick={toggleFullScreen}
              alt="expand"
              src={isFullScreen ? CollapseIcon : ExpandIcon}
            />
            <CROSS_BLACK_ICON
              className="w-6 h-6 cursor-pointer hover:opacity-60"
              onClick={handleClose}
            />
          </div>
        </div>
        {/* Chatbot Content */}
        <div className={`flex gap-3`}>
          <div
            className={`flex flex-col bg-white rounded p-4 h-[500px] ${
              isFullScreen ? "model-section lg:px-36" : "chatBotContent"
            } ${
              isCitations && !isFullScreen
                ? "hidden"
                : isCitations
                ? "w-8/12"
                : "w-full"
            }`}
          >
            {/* Chat Messages */}
            <div
              className="flex flex-col flex-grow overflow-y-auto p-2"
              ref={sectionRef}
            >
              <div className={`flex flex-col space-y-2 pb-3`}>
                <div
                  className={`justify-items-center ${
                    messages?.length != 0 && "hidden"
                  }`}
                >
                  <img className="w-10 pb-2" alt="NIEIcon" src={NIEIcon} />
                  <p className="text-black text-lg font-semibold pb-3">
                    {chatbotDetails[0]?.title}
                  </p>
                  <p className="whitespace-pre-line text-center pb-3">
                    {chatbotDetails[0]?.description}
                  </p>
                  <p className="whitespace-pre-line text-center text-sm text-gray-500">
                    {chatbotDetails[0]?.instruction}
                  </p>
                </div>
                {messages?.map((msg, index) => (
                  <div key={index} className="mb-3">
                    {/* Prompt shown like user message */}
                    <div
                      className={`${
                        isFullScreen ? "ml-16" : ""
                      } mb-3 chatBot-SenderMsg text-white float-right w-auto word-break-break-word markdown-body whitespace-normal p-2 rounded-lg`}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: msg?.prompt
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/ /g, "&nbsp;")
                            .replace(/\n/g, "<br/>"),
                        }}
                      />
                    </div>
                    {/* Response shown like bot message */}
                    <div className={`${isFullScreen ? "mr-16" : ""}`}>
                      {msg.response && (
                        <div
                          className={`mb-3 bg-gray-200 text-black self-start w-full word-break-break-word markdown-body whitespace-normal p-2 rounded-lg`}
                        >
                          {/* <ReactMarkdown>{msg.response}</ReactMarkdown> */}
                          <ChatBotMarkDownContent htmlContent={msg.response} />
                          {msg?.citations != null &&
                          msg?.citations.length > 0 ? (
                            <>
                              <span className="text-xs mb-1 text-gray-500">
                                This chatbot can make mistakes. Always refer to
                                official documents.
                              </span>
                              <div className="flex flex-wrap mb-2 cursor-pointer gap-2">
                                {msg?.citations?.map((i, index) => (
                                  <span
                                    className="border rounded-md p-1.5 bg-white border-gray-400 font-normal text-xs text-blue-500"
                                    onClick={() => {
                                      setCitationsContent(i);
                                      setIsCitations(true);
                                    }}
                                  >
                                    {i?.source}
                                  </span>
                                ))}
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {/* {messages?.length - 1 === index && citationsRecords?.length > 0 ?
                                                        <>
                                                            {citationsRecords?.map((i, index) => (
                                                                <div className="flex flex-wrap mb-2 cursor-pointer" >
                                                                    <span className="border rounded-md p-1.5 bg-white border-gray-400 font-normal text-xs text-blue-500" onClick={() => { setCitationsContent(i); setIsCitations(true); }}>
                                                                        {i?.source}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </>
                                                        : <></>
                                                    } */}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div ref={bottomRef} />
                {
                  loading && <div class="loader"></div>
                  //<CircularProgress className="self-center" />
                }
              </div>

              <div
                className={`flex flex-wrap gap-2 mt-auto items-center justify-center ${
                  messages?.length != 0 && "hidden"
                }`}
              >
                {Object.entries(chatbotDetails[0]?.questions || {})?.map(
                  ([key, question], index) => {
                    if (!question) return null; // skip empty strings
                    return (
                      <ButtonChatBot
                        key={key}
                        text={question}
                        color="white"
                        style="border-2 font-normal text-xs rounded-3xl"
                        onClick={() => btnQuestion(question)}
                      />
                    );
                  }
                )}
              </div>
              {chatbotDetails[0]?.is_followup_question_required && (
                <div
                  className={`flex flex-wrap gap-2 mt-auto items-center justify-center ${
                    followUpQuestions?.length == 0 && "hidden"
                  }`}
                >
                  {followUpQuestions?.map((question, index) => {
                    const questionText =
                      typeof question === "string" && question;
                    if (!questionText) return null;

                    return (
                      <ButtonChatBot
                        key={index}
                        text={questionText}
                        color="white"
                        style="border-2 font-normal text-xs rounded-3xl"
                        onClick={() => btnQuestion(questionText)}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            {atTop && (
              <>
                <ArrowCircleDownIcon
                  ref={arrowRef}
                  className={`${loading && "d-none"} ${
                    isFullScreen
                      ? "chatbot-down-arrow-FullScreen"
                      : "chatbot-down-arrow"
                  } m-auto left-1/2 transform -translate-x-1/2 text-4xl cursor-pointer modelIndex hover:text-gray-600`}
                  onClick={handleScrollToSection}
                />
              </>
            )}
            <div
              className={`flex items-center justify-center pt-1 ${
                !loading && "hidden"
              }`}
            >
              <ButtonChatBot
                key={5}
                text={"Stop Generation"}
                color="white"
                style={"border-2 font-normal text-sm rounded-3xl gap-1"}
                onClick={() => handleStop()}
              >
                <CheckBoxOutlineBlankIcon className="w-6 h-6 opacity-20" />
              </ButtonChatBot>
            </div>

            {/* Input Box */}
            <div className={`pt-3 w-full`}>
              <div
                className={`relative w-full flex items-center border-2 rounded-lg p-0.5`}
              >
                <textarea
                  value={input}
                  placeholder="Type a question..."
                  rows="1"
                  ref={textareaRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && loading) {
                      e.preventDefault();
                    }
                    if (e.key === "Enter" && !e.ctrlKey && !loading) {
                      // Just Enter → send
                      e.preventDefault();
                      handleSend("");
                    }

                    if (e.key === "Enter" && e.ctrlKey) {
                      // Ctrl + Enter → add newline explicitly
                      e.preventDefault();
                      const textarea = textareaRef.current;
                      const { selectionStart, selectionEnd } = textarea;

                      const newValue =
                        input.substring(0, selectionStart) +
                        "\n" +
                        input.substring(selectionEnd);

                      setInput(newValue);

                      // put cursor after newline
                      requestAnimationFrame(() => {
                        textarea.selectionStart = textarea.selectionEnd =
                          selectionStart + 1;
                      });
                    }
                  }}
                  className="text-sm w-full px-3 pr-5 pt-1 outline-none text-black border-none"
                  onChange={(e) => {
                    const textarea = textareaRef.current;
                    textarea.style.height = "auto"; // reset height
                    textarea.style.height = `${Math.min(
                      textarea.scrollHeight,
                      200
                    )}px`; // limit to maxHeight
                    //handleChange(e);
                    setInput(e.target.value);
                  }}
                  style={{
                    overflow: "auto",
                    resize: "none",
                    maxHeight: "200px",
                    minHeight: "75px",
                  }}
                />

                {!loading && (
                  <IconButton
                    color="primary"
                    onClick={() => handleSend("")}
                    className="absolute right-0 bottom-0 mt-auto"
                  >
                    <SendIcon />
                  </IconButton>
                )}
              </div>
              <div className="flex gap-2 mt-2 justify-start">
                <div>
                  <ButtonChatBot
                    key={5}
                    text={"Clear Chat"}
                    color="white"
                    style={"border-2 font-normal text-xs rounded-3xl px-1"}
                    aria-describedby={id}
                    onClick={handlePopupClick}
                  >
                    <CROSS_BLACK_ICON className="chatbot-icons text-gray-500 cursor-pointer hover:opacity-60" />
                  </ButtonChatBot>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopupClose}
                    anchorOrigin={{
                      vertical: "top", // or 'top', based on where you want to anchor **from**
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom", // or 'bottom', based on how the Popover should expand
                      horizontal: "center",
                    }}
                  >
                    <div className="flex flex-col items-center p-2 rounded-3xl">
                      <p className="text-center text-xs px-5">
                        <b>Note:</b> Your chat history will not be stored.
                        Please download a copy for your own reference.
                      </p>
                      <p className="mt-2 text-sm">
                        Are you sure you want to clear?
                      </p>
                      <div className="flex gap-2 mt-2">
                        <button
                          className="border-2 font-normal text-xs rounded-3xl px-4 p-1"
                          onClick={handleDelete}
                        >
                          Yes
                        </button>
                        <button
                          className="border-2 font-normal text-xs rounded-3xl px-4 p-1"
                          onClick={handlePopupClose}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </Popover>
                </div>
                <ButtonChatBot
                  key={6}
                  text={downloadChat}
                  color="white"
                  isdisabled={downloadChat == "Loading..." ? true : false}
                  style={"border-2 font-normal text-xs rounded-3xl px-1"}
                  onClick={() => handleDownload()}
                >
                  <FileDownloadOutlinedIcon
                    className={`chatbot-icons text-gray-500 ${
                      downloadChat == "Loading..."
                        ? "cursor-not-allowed"
                        : "cursor-pointer hover:opacity-60"
                    } `}
                  />
                </ButtonChatBot>
              </div>
            </div>
          </div>
          {/* Citations */}
          <div
            className={`flex-1 flex-col bg-white rounded p-2 h-[500px] overflow-auto ${
              isFullScreen ? "model-section" : "chatBotContent"
            } ${isCitations ? "block" : "hidden"} `}
          >
            <div className="bg-white p-1 flex justify-between">
              <div className="flex">
                <span className="text-black text-md font-semibold">
                  {citationsContent?.source
                    ? citationsContent?.source
                    : "Citations"}
                </span>
              </div>
              <div className="flex">
                <CROSS_BLACK_ICON
                  className="w-3 h-6 cursor-pointer hover:opacity-60"
                  onClick={handleCitations}
                />
              </div>
            </div>
            <div className="pt-2">
              <p>
                <ChatBotMarkDownContent
                  htmlContent={citationsContent?.content}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
